import { render, staticRenderFns } from "./NacexShippingForm.vue?vue&type=template&id=bbba9eb6&scoped=true"
import script from "./NacexShippingForm.vue?vue&type=script&lang=js"
export * from "./NacexShippingForm.vue?vue&type=script&lang=js"
import style0 from "./NacexShippingForm.vue?vue&type=style&index=0&id=bbba9eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbba9eb6",
  null
  
)

export default component.exports